export default "/images/4c34163f030921054288ae4aa458f3e8.avif";